import { ON_INACTIVE_CLIENT, ON_INACTIVE_CLIENT_FAIL, ON_INACTIVE_CLIENT_SUCCESS, GET_CLIENT_SETTING, GET_CLIENT_SETTING_FAIL, GET_CLIENT_SETTING_SUCCESS } from "./actionType"


// getClientSetting 
export const getClientSetting = data => ({
    type: GET_CLIENT_SETTING,
    payload: data,
  })
  export const getClientSettingSuccess = event => ({
      type: GET_CLIENT_SETTING_SUCCESS,
    payload: event,
  })
  export const getClientSettingFail = error => ({
    type: GET_CLIENT_SETTING_FAIL,
    payload: error,
  })

  //------------------

  //  inactiveClient

export const inactiveClient = data => ({
  type: ON_INACTIVE_CLIENT,
  payload: data,
})
export const inactiveClientSuccess = event => ({
    type: ON_INACTIVE_CLIENT_SUCCESS,
  payload: event,
})
export const inactiveClientFail = error => ({
  type: ON_INACTIVE_CLIENT_FAIL,
  payload: error,
})

  //------------------
